"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _BottomNavigation.default;
  }
});
Object.defineProperty(exports, "BottomNavigationAction", {
  enumerable: true,
  get: function get() {
    return _BottomNavigationAction.default;
  }
});

var _BottomNavigation = _interopRequireDefault(require("./BottomNavigation"));

var _BottomNavigationAction = _interopRequireDefault(require("./BottomNavigationAction"));


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/BottomNavigation/index.js
// module id = 1182
// module chunks = 52252321336229